// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
// Components
import OMAutocompleteInput from '../../components/OMComponents/OMAutocompleteInput/OMAutocompleteInput';
// Helpers
import { enterKey, inputStyleTheme } from '../../constants';
import highlightSuggestion from '../../helpers/highlightSuggestion';


class PublishAutocompleteLocationInput extends Component {
  state = {
    prefilled: false,
    suggestions: [],
    value: ''
  };

  componentWillReceiveProps({ suggestions = [], fieldValue = '', initialValue = '', inFocus }) {
    const stateModifier = { suggestions };
    if (this.state.value && !fieldValue && !inFocus) {
      stateModifier.value = '';
    }
    if (initialValue && !this.state.prefilled) {
      stateModifier.value = initialValue;
      stateModifier.prefilled = true;
    }
    this.setState({ ...stateModifier });
  }

  onKeyDown = (event) => {
    if (event.keyCode === enterKey) {
      event.preventDefault();
      this.setState({
        value: event.target.value
      }, () => {
        document.activeElement.blur();
      });
    }
  };

  getSuggestionValue = suggestion => suggestion ?
      get(suggestion, 'structured_formatting.main_text', '') || get(suggestion, 'description', '')
      // get(suggestion, 'description', '') || get(suggestion, 'structured_formatting.main_text', '')
      : '';

  getInputValue = (value) => {
    value = (value || '').trim();
    this.setState({ value });
    if (value) {
      this.props.receiveSuggestions({ ...this.props.params, query: value });
    }
    this.props.onQueryStringChange(this.props.params.type, value);
  };

  highLightSuggestion = (suggestion, ctx) =>
    highlightSuggestion({ ...suggestion, address: this.getSuggestionValue(suggestion) }, ctx);

  handleBlur = (evt) => {
    evt.target.setAttribute('autocomplete', evt.target.name);
    this.setState({
      suggestions: []
    });
    this.props.handleBlur(this.state.value);
  };

  handleFocus = (evt) => {
    evt.target.setAttribute('autocomplete', 'off');
    this.setState({
      suggestions: []
    }, () => { this.props.handleFocus(this.props.params.type); });
  };

  render() {
    return (
      <OMAutocompleteInput
        inputName={this.props.name}
        inputValue={this.state.value}
        initialValue={this.props.initialValue}
        placeholder={this.props.placeholder}
        theme={inputStyleTheme}
        getInputValue={this.getInputValue}
        suggestions={this.state.suggestions.slice(0, 5)}
        getSuggestionValue={this.getSuggestionValue}
        selectedSuggestion={this.props.searchSelectedOption}
        onKeyDown={this.onKeyDown}
        deferRequestBy={300}
        className={this.props.className}
        renderSuggestions={this.highLightSuggestion}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        isMobile={this.props.isMobile}
        allowEmptyInput
        isValid
      />
    );
  }
}

PublishAutocompleteLocationInput.propTypes = {
  name: PropTypes.string.isRequired,
  suggestions: PropTypes.array,
  locale: PropTypes.string,
  translate: PropTypes.func,
  receiveSuggestions: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onQueryStringChange: PropTypes.func,
  fieldValue: PropTypes.string,
  requestString: PropTypes.func,
  handleFocus: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  params: PropTypes.object.isRequired,
  searchSelectedOption: PropTypes.func,
  inFocus: PropTypes.bool,
  isMobile: PropTypes.bool,
  initialValue: PropTypes.string
};

export default PublishAutocompleteLocationInput;
